module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-6-4a69604403fe2941f4568f043f4281f1.webp";